import axios from 'axios';

import apolloProvider from '@/vue-apollo';
const apolloClient = apolloProvider.defaultClient;

import AuthenticatedMemberGql from '@/extensions/restricted-area/store/graphql/queries/AuthenticatedMember.gql';

import { trim } from '@/helpers';

const AUTH_ENDPOINT = trim(
  `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_MEMBER_AUTH_ROUTE}`,
  '/'
);
const REGISTER_ENDPOINT = trim(
  `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_MEMBER_REGISTER_ROUTE}`,
  '/'
);
const PASSWORD_ENDPOINT = trim(
  `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_MEMBER_PASSWORD_ROUTE}`,
  '/'
);
const MEMBER_EMAIL_VERIFICATION_ENDPOINT = trim(
  `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_MEMBER_EMAIL_VERIFICATION_ROUTE}`,
  '/'
);

const ZXCVBN_ENDPOINT = trim(
  `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_ZXCVBN_ROUTE}`,
  '/'
);

export default {
  setToken(token) {
    return localStorage.setItem('member-token', token);
  },
  getToken() {
    return localStorage.getItem('member-token') || '';
  },
  removeToken: () =>
    new Promise(resolve => {
      // TODO
      // invalidate token server side

      localStorage.removeItem('member-token');
      setTimeout(() => resolve(), 150);
    }),
  register(member) {
    return new Promise((resolve, reject) => {
      axios
        .post(REGISTER_ENDPOINT, member)
        .then(result => resolve(result))
        .catch(error => reject(error));
    });
  },
  login(member) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${AUTH_ENDPOINT}/login`, member)
        .then(result => resolve(result))
        .catch(error => reject(error));
    });
  },
  sendResetLinkEmail(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${PASSWORD_ENDPOINT}/email`, payload)
        .then(result => resolve(result))
        .catch(error => reject(error));
    });
  },
  resetPassword(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${PASSWORD_ENDPOINT}/reset`, payload)
        .then(result => resolve(result))
        .catch(error => reject(error));
    });
  },
  verifyEmail(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${MEMBER_EMAIL_VERIFICATION_ENDPOINT}?expires=${payload.expires}&hash=${payload.hash}&id=${payload.id}&signature=${payload.signature}`
        )
        .then(result => resolve(result))
        .catch(error => reject(error));
    });
  },
  fetchAuthenticatedMember: () =>
    new Promise((resolve, reject) => {
      apolloClient
        .query({
          query: AuthenticatedMemberGql,
          fetchPolicy: 'no-cache'
        })
        .then(({ data }) => resolve(data.CP_AuthenticatedMember))
        .catch(error => reject(error.message));
    }),
  getPasswordStrength(password) {
    return new Promise((resolve, reject) => {
      const payload = {
        password,
        user: this.user
      };

      axios
        .post(ZXCVBN_ENDPOINT, payload)
        .then(({ data }) => resolve(data))
        .catch(error => reject(error.message));
    });
  }
};
